__webpack_require__.p = "/mini_project_quiz/";